$(window).on("load", () => {
  var audio = $("#audio-podcast")[0];
  let startTime = 0;
  let pageID = $("#audio-podcast").attr("data-page-id");

  if (pageID) {
    $.get(
      "/wp-json/video/start/",
      { wpId: pageID },
      function (data) {
        audio.currentTime = data.start;
        startTime = data.start;
      },
      "json"
    );
  }
  $("#audio-podcast").on("play", function () {
    startTime = audio.currentTime;
  });
  $("#audio-podcast").on("ended pause", function () {
    sendingStatistics(pageID, startTime, audio.currentTime);
  });

  function sendingStatistics(id, begin, end) {
    let data = {
      wpId: parseInt(id),
      begin: parseInt(begin),
      end: parseInt(end),
    };

    $.ajax({
      url: "/wp-json/video/log",
      type: "POST",
      data: JSON.stringify(data),
      contentType: "application/json",
      complete: callback,
    });

    function callback(response) {
      return response;
    }
  }
});
